<template>
  <div>
    <Modal v-model="isShowModal" width="1500px" height="1500px">
      <baidu-map class="map" v-if="isShowModal" :center="map.center" :zoom="map.zoom" @ready="handler">
        <!--缩放-->
        <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
        <!--定位-->
        <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"></bm-geolocation>
        <!--点-->
        <bm-marker :position="map.center" :dragging="map.dragging" animation="BMAP_ANIMATION_DROP">
          <!--提示信息-->
          <bm-info-window :show="map.show">{{this.address}}</bm-info-window>
        </bm-marker>

        <view v-for="recovery in recoveryUserList">
          <bm-polygon :path="recovery.mapRange" stroke-color="blue" :stroke-opacity="0.5" :stroke-weight="2" :editing="false" @click="clicking(recovery.realName)"/>
        </view>
      </baidu-map>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "demo",
  data: () => ({
    isShowModal: false,
    show1: false,
    // position: { lng: '', lat: '',title:'' },
    address: '',
    // mapObj: [
    // ],//结构[{ lng: '', lat: '',title:''}]
    map:{
      center: {},
      zoom: 15,
      show: true,
      dragging: true
    },
    recoveryUserList: []
  }),
  methods: {
    clicking(name) {
      this.$Message.success('回收人员：' + name);
    },
    // 显示模态框
    show(row) {
      setTimeout(() => {
        this.isShowModal = true;
      }, 1000)
      let x_pi = Math.PI * 3000.0 / 180.0;//Math.PI ~ 3.14159265358979324
      let x = row.address.longitude;
      let y = row.address.latitude;
      let z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi);
      let theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi);
      let lngs = z * Math.cos(theta) + 0.0065;
      let lats = z * Math.sin(theta) + 0.006;
      this.map.center = {lng: lngs, lat: lats}
      this.address = row.address.locationAddress + row.address.address
      this.findRecoveryUserList();
    },
    handler ({BMap, map}) {
      // 鼠标缩放
      map.enableScrollWheelZoom(true);
    },
    showItem(item) {
      console.log('点击')
      this.show1 = true
    },
    infoWindowClose() {
      this.show1 = false
    },
    infoWindowOpen() {
      this.show1 = true
    },
    findRecoveryUserList() {
      let params = {
        page: 1,
        rows: 99,
      }
      this.axios.post('/recoveryUser/findList', params).then(res => {
        if (res.status == 200) {
          let rows = res.data.rows
          if (rows) {
            let recoveryUser = []
            rows.forEach(item => {
              if (item.mapRange) {
                let mapRangeStr = item.mapRange.substring(2);
                mapRangeStr = mapRangeStr.substring(0, mapRangeStr.length - 2);
                console.log('mapRange', mapRangeStr);
                let mapRange = []
                let mapRangeArr = mapRangeStr.split(';');
                mapRangeArr.forEach(v => {
                  let local = v.split(',');
                  let item = {
                    lng: local[0],
                    lat: local[1]
                  }
                  mapRange.push(item);
                });
                item.mapRange = mapRange
                recoveryUser.push(item);
              }
            });
            this.recoveryUserList = recoveryUser
          }
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询回收员列表接口报错',
            duration: 0
          });
        }
      })
    },
  }
}
</script>

<style scoped>
.map {
  width: 100%;
  height: 900px;
}
</style>